// extracted by mini-css-extract-plugin
export default {"root":"HqioZq","checked":"X40trv"};